import React, { useContext } from "react";
import Trash from "../../assets/imgs/trash.svg";
import Pagamento from "../../assets/imgs/pagamento.svg";
import "./CarrinhoContent.css";
import { CarrinhoContext } from "../../services/context/CarrinhoContext";
import { Link } from "react-router-dom";

function CarrinhoContent({ onCloseCarrinho }) {
  const main = process.env.REACT_APP_MAIN;
  const {
    carrinho,
    modificarQuantidade,
    removerItem,
    limparCarrinho,
    valorTotal,
  } = useContext(CarrinhoContext);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Smooth scroll behavior
    });
  };

  const calculateItemTotal = (preco, quantidade) => {
    return preco * quantidade;
  };

  return (
    <div className="carrinho-content-container">
      <h2 className="main-title">Seu Carrinho</h2>

      {carrinho.length === 0 ? (
        <div className="d-flex flex-column align-items-center justify-content-center mt-5">
          <img
            src="https://cdn-icons-png.flaticon.com/512/2038/2038854.png"
            alt="Carrinho vazio"
            className="mb-3"
            style={{ maxWidth: '150px' }}
          />
          <h3 className="text-muted mb-2">Seu carrinho está vazio!</h3>
          <p className="text-muted text-center">
            Parece que você ainda não adicionou nenhum produto.<br />
            Que tal explorar a loja e encontrar algo interessante?
          </p>

        </div>
      ) : (
        <>
          <div className="carrinho-content carrinho-sidebar">
            {carrinho.map((item) => (
              <>
                <div className="product-flex">
                  <div className="carrinho-item-img">
                    <img
                      src={`https://insigneacademica.com.br/api/public/${item.image}`}
                      alt="productImage"
                    ></img>
                  </div>
                  <div className="item" key={item.id}>
                    <div className="product-flex">
                      <div><strong>{item.titulo}</strong></div>

                      <div>
                        <div>
                          Valor: R${calculateItemTotal(item.preco, item.quantidade)}
                        </div>
                        <button onClick={() => removerItem(item.id, item.formato)}>Remover</button>


                      </div>
                    </div>
                  </div>
                </div>

                <div className="carrinho-break"></div>
              </>
            ))}
          </div>

          <div className="carrinho-valores-container">
            <div>Total: R${valorTotal.toFixed(2)}</div>
          </div>

          <div className="btns-carrinho">
            <Link
              to={main + "checkout/"}
                onClick={() => {
                  onCloseCarrinho();
                  scrollToTop();
                }}
              className="main-btn-orange"

            >
              <img className="img-trash" src={Pagamento} alt="" />
              Continuar para pagar
            </Link>
            <button className="main-btn-blue" onClick={limparCarrinho}>
              <img className="img-trash" src={Trash} alt="" />
              Limpar Carrinho
            </button>
          </div>
        </>
      )}
    </div>
  );
}

export default CarrinhoContent;
